/* eslint-disable no-console */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "JsonReporter", {
    enumerable: true,
    get: function() {
        return JsonReporter;
    }
});
const _formathrtime = require("@lage-run/format-hrtime");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class JsonReporter {
    log(entry) {
        if (entry.data && entry.data.target && entry.data.target.hidden) {
            return;
        }
        if (this.options.logLevel >= entry.level) {
            console.log(this.options.indented ? JSON.stringify(entry, null, 2) : JSON.stringify(entry));
        }
    }
    summarize(schedulerRunSummary) {
        const { duration, targetRuns, targetRunByStatus } = schedulerRunSummary;
        const summary = {};
        const taskStats = [];
        for (const targetRun of targetRuns.values()){
            taskStats.push({
                package: targetRun.target.packageName,
                task: targetRun.target.task,
                duration: (0, _formathrtime.hrToSeconds)(targetRun.duration),
                status: targetRun.status
            });
        }
        for (const status of Object.keys(targetRunByStatus)){
            if (targetRunByStatus[status] && targetRunByStatus[status].length.length > 0) {
                summary[`${status}Targets`] = targetRunByStatus[status].length;
            }
        }
        summary.duration = (0, _formathrtime.hrToSeconds)(duration);
        summary.taskStats = taskStats;
        console.log(JSON.stringify({
            summary
        }));
    }
    constructor(options){
        _define_property(this, "options", void 0);
        this.options = options;
    }
}
